import { CSSTransition } from "react-transition-group";
import { BiCheck, BsCaretDownFill } from "react-icons/all";
import { useEffect, useRef, useState } from "react";
import OnOutsideClick from "react-outclick";
import { toast } from "react-hot-toast";
import NavBar from "../Components/Dashboard/Components/NavBar";
import { useFlexLayout, useTable } from "react-table";
import gsap from "gsap";
export function Container({ children, contRef, maxWidth }) {
    return (
        <div className="container" ref={contRef} style={{ maxWidth }}>
            {children}
        </div>
    );
}

export function Grid({ children, gridRef }) {
    return (
        <div className="grid" ref={gridRef}>
            {children}
        </div>
    );
}

export function GridItem({ children, icon, header }) {
    return (
        <div className="grid_item">
            <div className="icon">{icon}</div>
            <div className="header">{header}</div>
            <p className="text">{children}</p>
        </div>
    );
}

export function InputField({ header, type = "text", placeholder }) {
    return (
        <div className="input_field">
            <h3 className="input_header">{header}</h3>
            <input type={type} placeholder={placeholder} />
        </div>
    );
}
export function TextAreaField({ header, placeholder }) {
    return (
        <div className="input_field">
            <h3 className="input_header">{header}</h3>
            <textarea placeholder={placeholder}></textarea>
        </div>
    );
}

export function InputFieldWithIcon({
    value = "",
    setValue,
    icon,
    button = false,
    placeholder,
    name,
    type,
    padding = 10,
}) {
    return (
        <div className="input_feild_with_icon" style={{ padding }}>
            {icon}
            <input
                type={type}
                name={name}
                value={value}
                onChange={({ target: { value } }) => {
                    setValue(value);
                }}
                placeholder={placeholder}
            />
            {button && (
                <CSSTransition
                    in={value.trim() !== ""}
                    unmountOnExit
                    timeout={400}
                    classNames="fade-scale"
                >
                    <button>submit</button>
                </CSSTransition>
            )}
        </div>
    );
}

export function Checkbox({
    name = "checkbox",
    text,
    Checked,
    exe,
    id,
    theme = "pry",
    type = "radio",
}) {
    return (
        <div className={`checkbox ${theme === "pry" ? "pry" : "white"}`}>
            <input type={type} name={name} checked={Checked || false} id={id} onChange={exe} />
            <label htmlFor={id}>
                <div className="check_box_icon">
                    <div className="icon">
                        <BiCheck />
                    </div>
                </div>
                {text}
            </label>
        </div>
    );
}

export function DropDown({
    timeout = 400,
    removeOnExit = true,
    header,
    dropListArray = [],
    setOption,
    customClassNames,
    initialOption,
    placeHolder,
    icon,
    disabled = false,
    errMsg,
    index,
    width,
    style,
}) {
    const [drop, setDrop] = useState(false);

    useEffect(() => {
        return function () {
            setDrop(false);
        };
    }, []);

    var list = dropListArray.map(({ render, value }, index) => {
        return (
            <li
                key={index}
                className="list-group-item p-2"
                onClick={() => {
                    setOption(value || render);
                    setDrop(false);
                }}
            >
                {render}
            </li>
        );
    });
    return (
        <div style={{ width: width || "100%", zIndex: index || 1, ...style, position: "relative" }}>
            <OnOutsideClick
                onOutsideClick={() => {
                    setDrop(false);
                }}
            >
                <div
                    className={`drop_down_wrapper ${drop ? "drop" : ""}`}
                    style={{ width: "100%" }}
                    onClick={() => {
                        if (disabled) {
                            return toast.error(errMsg);
                        }
                        setDrop(!drop);
                    }}
                >
                    <div
                        className={` dropDown d-flex align-items-center justify-content-between ${customClassNames}`}
                    >
                        {icon}
                        {initialOption || placeHolder}
                        <span>
                            <BsCaretDownFill size="1.4rem" />
                        </span>
                    </div>
                    <CSSTransition
                        in={drop}
                        timeout={timeout}
                        classNames="drop"
                        unmountOnExit={removeOnExit}
                    >
                        <div
                            className="card drop-down shadow rounded-0 p-0"
                            style={{ zIndex: drop ? 50 : 0 }}
                        >
                            <div className="card-header p-2 font-weight-bold">{header}</div>

                            <div className="card-body">
                                <ul className="list-group">{list}</ul>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </OnOutsideClick>
        </div>
    );
}

export function Card({ round, children, shadow, className, cardRef, styles }) {
    return (
        <div
            className={`card ${className || ""}`}
            style={{
                borderRadius: round || 15,
                boxShadow: shadow || "0px 4px 26px -11px rgba(60, 69, 100, 0.2)",
                ...styles,
            }}
            ref={cardRef}
        >
            {children}
        </div>
    );
}

export function DashPopUp({ children, close_exe, clean_up, state = false }) {
    useEffect(() => {
        document.querySelector(".dashboard").style.background = "white";
        return (document.querySelector(".dashboard").style.background =
            "linear-gradient(97.94deg, rgba(105, 117, 151, 0.1) 2.89%, rgba(255, 255, 255, 0.09) 95.96%)");
    }, []);
    return (
        <CSSTransition in={state} classNames="dash_pop_up" timeout={400} unmountOnExit>
            <div id="dash_pop_up">
                <div className="wrapper">
                    <NavBar />
                    {children}
                </div>
            </div>
        </CSSTransition>
    );
}

export function Loader() {
    return (
        <div className="loading">
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}

export function GraphCircle({ fill, progress, className }) {
    return (
        <div className={"graph_circle " + className}>
            <svg id="Layer_1" viewBox="0 0 194.71 194.71">
                <circle className="cls-1 bottom" cx="97.36" cy="97.36" r="92.36" />
                <circle
                    className="cls-2 top"
                    stroke={fill}
                    cx="97.36"
                    cy="97.36"
                    r="92.36"
                    style={{
                        strokeDashoffset: 579.3775024414062 - (579.3775024414062 * progress) / 100,
                    }}
                />
            </svg>
        </div>
    );
}

export function ConfirmModal({ state, control, children }) {
    return (
        <CSSTransition in={state} classNames="modal_anim" timeout={400} unmountOnExit>
            <div
                className="modal"
                onClick={() => {
                    control(false);
                }}
            >
                <div
                    className="modal_content"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    {children}
                </div>
            </div>
        </CSSTransition>
    );
}

export function Table({ columns, data, no_data_text, width, padding, anim_delay }) {
    const table = useRef();
    useEffect(() => {
        const tl = gsap.timeline();

        tl.from(table.current.children[0].children[0].children, {
            opacity: 0,
            stagger: { each: 0.125 },
            duration: 1,
            delay: anim_delay,
        }).from(
            table.current.children[1].children,
            {
                opacity: 0,
                scale: 0.7,
                stagger: { each: 0.125 },
            },
            "-=.75"
        );
    }, [anim_delay]);
    const tableInstance = useTable({ columns, data, minWidth: width, width }, useFlexLayout);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;
    return (
        <div className="table_wrapper scroll">
            <table {...getTableProps()} className="custom_table" ref={table}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.length === 0 ? (
                        <span
                            style={{
                                textAlign: "center",
                                fontSize: 20,
                                padding: padding,
                                display: "block",
                                fontWeight: 700,
                            }}
                        >
                            {no_data_text}
                        </span>
                    ) : (
                        rows.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                        );
                                    })}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );
}
